import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";
import { typeLabel } from "@/utils/movieUtils";

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
      data-product-shop
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 封面`}
          title={`${movie.title} 日本影视`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded bg-primary-500/95 px-2 py-0.5 text-xs font-medium text-background-50">
          {typeLabel(movie.type)}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-0.5 rounded bg-foreground-950/70 px-1.5 py-0.5 text-xs font-medium text-accent-300">
          <i className="ri-star-fill" aria-hidden="true"></i>
          {movie.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-1.5 p-3">
        <h3 className="line-clamp-1 font-heading text-base font-semibold text-foreground-900 transition-colors group-hover:text-primary-600">
          {movie.title}
        </h3>
        <p className="line-clamp-2 text-xs leading-relaxed text-foreground-500">
          {movie.synopsis}
        </p>
        <div className="mt-auto flex flex-wrap items-center gap-1.5 pt-1 text-xs text-foreground-400">
          <span>{movie.year}</span>
          <span className="text-background-400">·</span>
          <span>{movie.region}</span>
          <span className="text-background-400">·</span>
          <span className="line-clamp-1">{movie.genres.join(" / ")}</span>
        </div>
      </div>
    </Link>
  );
}